import { useSelector } from 'react-redux';
import { dispatch, Store } from '../../redux';
import { useEffect } from 'react';
import { useFirebase } from '../lib';
import { getStoredMode, getUser, updateUserState } from '../../redux/reducers';
import {
  bootstrapGuestSession,
  loadGuestProfile,
  refreshGuestUser,
} from '@/screens/guest/session';
import { LoggerService } from '../logger';

export const useIsAuth = () => {
  const user = useSelector((state: Store) => state.userReducer);
  const { isProcessing, checkFirebaseAuth } = useFirebase();

  useEffect(() => {
    let cancelled = false;
    dispatch(getStoredMode());

    const startAccountFlow = () =>
      checkFirebaseAuth(isAuth => {
        if (!isAuth) {
          dispatch(updateUserState({ isIdle: false }));
        }
      });

    // Guests are restored from their stored token without touching Firebase.
    // Everyone else keeps the original Firebase → stored-token flow.
    bootstrapGuestSession()
      .then(handledAsGuest => {
        if (cancelled || handledAsGuest) return;
        startAccountFlow();
      })
      .catch(err => {
        LoggerService.error('Guest bootstrap failed', err);
        if (!cancelled) startAccountFlow();
      });

    return () => {
      cancelled = true;
    };
  }, [checkFirebaseAuth]);

  useEffect(() => {
    if (user.userType !== 'guest' || !user.token) return;
    const token = user.token;
    const timer = window.setInterval(
      async () => {
        await refreshGuestUser(token, await loadGuestProfile());
      },
      30 * 60 * 1000
    );
    return () => window.clearInterval(timer);
  }, [user.userType, user.token]);

  return {
    isAuthenticated: user?.isAuthenticated,
    isGuest: user?.userType === 'guest',
    isLoading: user?.isLoading || isProcessing,
    isError: user?.isError,
    token: user?.token,
    user,
    getUser,
    isIdle: user?.isIdle,
  };
};
